// src/modules/app-views/account/pages/Init/modals/ChangePasswordModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import SimplePassword from 'components/SimpleComponents/SimplePassword';
import appService from 'services/appService';
import FirebaseService from 'services/FirebaseService';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const CurrentPasswordStepContent = () => (
  <>
    <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
      {translateX('enter_current_password_description')}
    </Text>
    <SimplePassword
      name="currentPassword"
      label="current_password"
      required
      autoComplete="current-password"
      prefix={<LockOutlined className="text-primary" />}
    />
  </>
);

// *******************************************************************************
// HELPERS
// *******************************************************************************
const validateCurrentPassword = async ({ form, setLoading, goFocus, storedUser }) => {
  const email = storedUser?.email?.value || storedUser?.email;
  const password = form?.getFieldValue('currentPassword');

  if (!password || password.trim() === '') {
    await appService.message({ flag: 'w', text: 'password_is_required' });
    goFocus?.('currentPassword', true);
    return false;
  }

  try {
    setLoading(true);
    await FirebaseService.reauthenticateUser(email, password);
    return true; // Allow proceed to next step
  } catch (reauthErr) {
    console.error('[ChangePasswordModal] Reauthentication error:', reauthErr);

    const errorCode = reauthErr?.message || '';
    if (
      errorCode.includes('auth/wrong-password') ||
      errorCode.includes('auth/invalid-credential')
    ) {
      await appService.message({ flag: 'w', text: 'incorrect_password' });
    } else {
      await appService.message({ flag: 'w', text: 'authentication_failed' });
    }

    // Focus back on password field when authentication fails
    goFocus?.('currentPassword', true);

    return false; // Don't proceed to next step
  } finally {
    setLoading(false);
  }
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const currentPasswordStep = ({ storedUser }) => ({
  stepTitle: 'current_password',
  stepTooltip: 'enter_current_password',
  content: () => <CurrentPasswordStepContent />,
  validationFields: ['currentPassword'],
  onNext: async ({ form, setLoading, goFocus }) =>
    validateCurrentPassword({ form, setLoading, goFocus, storedUser }),
  onEnter: ({ goFocus }) => {
    // Focus on the password field when entering this step
    setTimeout(() => goFocus?.('currentPassword'), 100);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default currentPasswordStep;
